import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { NipNumberControlProps } from './NipNumberControl.interfaces';
import { useNipNumberControl } from './useNipNumberControl';

export default function NipNumberControl(props: NipNumberControlProps) {
  const {
    meta,
    tooltip,
    input,
    disabled,
    label,
    subLabel,
    helperText,
    width,
    margin,
    placeholder,
    className,
    id,
    defaultAlertStyle,
    duplicateLabel,
  } = props;

  const {
    focused,
    error,
    handleBlur,
    handleChange,
    onFocus,
    handleClick,
  } = useNipNumberControl(props);

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        meta={meta}
        tooltip={tooltip}
        subLabel={subLabel}
        helperText={helperText}
        floating
        floated
        disabled={disabled}
        width={width}
        className={className}
        defaultAlertStyle={defaultAlertStyle}
        label={duplicateLabel ? label : ''}
      >
        <TextField
          InputProps={{
            name: input.name,
            disabled: disabled,
            startAdornment: !focused &&
              !error &&
              UtilService.hasValue(input.value) && <DoneAdornment />,
          }}
          label={duplicateLabel ? placeholder : label}
          error={error}
          variant={'outlined'}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={handleBlur}
          onClick={handleClick}
          margin={margin || 'dense'}
          type="tel"
          value={input.value}
          id={id}
          fullWidth
        />
      </ControlContainer>
    </FormControl>
  );
}
